import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AlertsService } from '../../../services/alerts.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css']
})
export class AlertsComponent implements OnInit {

  subscription;
  data = {
    messageType: '',
    message: '',
    title: ''
  };

  constructor ( public alerts: AlertsService ) {
    this.alerts = alerts;
  }

  ngOnInit ( ) {
    this.subscription = this.alerts.getData( )
      .subscribe( item => { this.data = item; });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/alerts/alerts.component.ts